import { render, staticRenderFns } from "./PeiXunPlanManager.vue?vue&type=template&id=0b729944"
import script from "./PeiXunPlanManager.vue?vue&type=script&lang=js"
export * from "./PeiXunPlanManager.vue?vue&type=script&lang=js"
import style0 from "./PeiXunPlanManager.vue?vue&type=style&index=0&id=0b729944&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports